export const filterArray = (array, text) => {
  let filteredArray = null
  filteredArray = array.filter(object => {
    const query = text.toLowerCase()
    return object.toLowerCase().startsWith(query)
  })
  return filteredArray
}


export const normalizeIndex = (selectedIndex, max) => {
  let index = selectedIndex % max
  if (index < 0) {
    index += max
  }
  return index
}

export const findAncestor = (el, match) => {
  if (el === null) {
    return false
  }
  if (el === match) {
    return true
  }
  return findAncestor(el.parentElement, match)
}
